module.exports = __webpack_public_path__ + "static/media/teamsMobile.ed6a9d2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/teamsMobile.jpg
// module id = 856
// module chunks = 9